import { useState, useEffect, useCallback } from 'react'

export type DensityMode = 'comfortable' | 'default' | 'compact'

const STORAGE_KEY = 'gracklecrm_density'

export function useDensity() {
  const [density, setDensityState] = useState<DensityMode>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    // Compact is the app-wide default; users can still switch via the avatar menu.
    return (stored as DensityMode) || 'compact'
  })

  useEffect(() => {
    document.documentElement.dataset.density = density
    localStorage.setItem(STORAGE_KEY, density)
  }, [density])

  const setDensity = useCallback((mode: DensityMode) => {
    setDensityState(mode)
  }, [])

  const cycleDensity = useCallback(() => {
    setDensityState((prev) => {
      switch (prev) {
        case 'comfortable':
          return 'default'
        case 'default':
          return 'compact'
        case 'compact':
          return 'comfortable'
      }
    })
  }, [])

  return { density, setDensity, cycleDensity }
}
